module.exports = __webpack_public_path__ + "static/media/logo-stripe.f29e640a.png";